import React from "react";

class TablaResumenMensual extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <table
        className="table table-bordered table-condensed table-hover table-condensed"
        style={{
          fontSize: "11px",
          textAlign: "center",
        }}
      >
        <thead>
          <tr>
            <th colSpan="3"></th>
            <th className="text-center">Programadas</th>
            <th className="text-center">Suspendidas</th>
            <th className="text-center" colSpan="2">
              Completadas
            </th>
            <th className="text-center" colSpan="2">
              Pendientes
            </th>
          </tr>
          <tr>
            <th className="text-center" colSpan="3">
              Regiones
            </th>
            <th className="text-center">Total</th>
            <th className="text-center">Total</th>
            <th></th>
            <th className="text-center">%</th>
            <th></th>
            <th className="text-center">%</th>
          </tr>
        </thead>
        <tbody>
          {this.props.data.regiones.length == 0 ? (
            <tr>
              <td colSpan={6}>Cargando...</td>
            </tr>
          ) : (
            this.props.data.regiones.map((region, index) => {
              let label1 =
                region.terminadasPorcentaje <= 25
                  ? "danger"
                  : region.terminadasPorcentaje <= 75
                  ? "warning"
                  : "success";
              let label2 =
                region.pendientesPorcentajeTerminar <= 25
                  ? "danger"
                  : region.pendientesPorcentajeTerminar <= 75
                  ? "warning"
                  : "success";
              return (
                <tr key={index}>
                  <td colSpan="3">{region.nombreRegion}</td>
                  <td>
                    <b>{region.totalMes}</b>
                  </td>
                  <td>
                    <b>{region.suspendidas}</b>
                  </td>
                  <td>
                    <b>{region.terminadas}</b>
                  </td>
                  <td>
                    <span className={`label label-${label1}`}>
                      {region.terminadasPorcentaje}%
                    </span>
                  </td>
                  <td>
                    <b>{region.pendientesTerminar}</b>
                  </td>
                  <td>
                    <span
                      className={`label label-${label2}`}
                      style={{
                        fontSize: "10px",
                        width: "35px",
                      }}
                    >
                      {region.pendientesPorcentajeTerminar}%
                    </span>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="3">
              <b>Total / Promedio</b>
            </td>
            <td>
              <b>{this.props.data == 0 ? 0 : this.props.data.totales.total}</b>
            </td>
            <td>
              <b>
                {this.props.data == 0 ? 0 : this.props.data.totales.suspendidas}
              </b>
            </td>
            <td>
              <b>
                {this.props.data == 0 ? 0 : this.props.data.totales.terminadas}
              </b>
            </td>
            <td>
              <b>
                {this.props.data == 0
                  ? 0
                  : this.props.data.totales.terminadasPorcentaje}
                %
              </b>
            </td>
            <td>
              <b>
                {this.props.data == 0
                  ? 0
                  : this.props.data.totales.pendientesTerminar}
              </b>
            </td>
            <td>
              <b>
                {this.props.data == 0
                  ? 0
                  : this.props.data.totales.pendientesPorcentajeTerminar}
                %
              </b>
            </td>
          </tr>
        </tfoot>
      </table>
    );
  }
}

export default TablaResumenMensual;



// WEBPACK FOOTER //
// ./frontEnd/auditorias/programacion-semanal/TablaResumenMensual.jsx